import React from "react";
import { getHeadshotPath } from "./utils";
import { useLanguage } from "../context/LanguageContext";

/**
 * Simplified hero section component with centered content and Emanuel.svg logo
 */
const HeroSection = () => {
  // Use headshot 6 specifically as requested
  const headshotNumber = 2;
  const { t } = useLanguage();

  return (
    <section className="relative min-h-screen flex items-center justify-center py-20 mt-0">
      {/* Background image with gradient overlay starting at the top */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black from-0% via-black/5 via-0.5% to-transparent to-70%"></div>
        <img
          src={getHeadshotPath(headshotNumber)}
          alt="Tudor Emanuel "
          className="w-full h-full object-cover"
        />
      </div>

      {/* Centered content */}
      <div className="container mx-auto px-6 relative z-10 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-5xl md:text-7xl font-bold mb-6 leading-tight text-white drop-shadow-lg">
            {t("heroTitle")} <span className="text-yellow-400">∞</span>
          </h1>

          <p className="font-accent text-xl md:text-2xl mb-10 text-white text-opacity-90 leading-relaxed drop-shadow max-w-2xl mx-auto font-light">
            {t("heroSubtitle")}
          </p>

          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <a
              href="#coaching"
              className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold py-4 px-8 rounded-lg transition shadow-xl text-center text-lg tracking-wide"
            >
              {t("exploreCoaching")}
            </a>
            <a
              href="#speaking"
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 border-2 border-white text-white font-semibold py-4 px-8 rounded-lg transition shadow-xl text-center text-lg tracking-wide"
            >
              {t("bookSpeaker")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
